import { Notification } from 'components/UI';
import { map } from 'es-toolkit/compat';
import { Autocomplete, User } from 'interfaces';
import { action, observable } from 'mobx';
import FetchableStore from 'stores/shared/FetchableStore';

class UsersPipedriveStore extends FetchableStore {
  @observable users: User[] = [];

  @action assignOnFetch = (payload: Autocomplete[]): void => {
    this.users = map(payload, (autocomplete: Autocomplete) => ({
      id: Number(autocomplete.value),
      name: autocomplete.label,
    }));
  };

  @action onFetchError(error: any) {
    super.onFetchError(error);

    Notification.Error('Failed to load pipedrive Users');
  }
}

export default UsersPipedriveStore;
